import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { LoaderService } from './loader.service';

@Injectable({
  providedIn: 'root',
})
export class InterceptorService implements HttpInterceptor {
  constructor(public loaderService: LoaderService) {}
  timer: NodeJS.Timeout;
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    //console.log('InterceptorService())');
    //const authReq = req.clone({
    // Prevent caching in IE, in particular IE11.
    // See: https://support.microsoft.com/en-us/help/234067/how-to-prevent-caching-in-internet-explorer
    //setHeaders: {'Cache-Control': 'no-cache',Pragma: 'no-cache', },
    //});
    if (this.timer) {
      //console.log('InterceptorService-Timer.limpei();');
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => {
      this.loaderService.isLoading.next(true);
      //console.log('InterceptorService-Emiti(true)');
    }, 500);

    return next.handle(req).pipe(
      finalize(() => {
        this.loaderService.isLoading.next(false);
        //console.log('InterceptorService-Emiti(false)');
        if (this.timer) {
          clearTimeout(this.timer);
        }
      })
    );
  }
}
